var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55.756351 66.702087",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a18930",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3c565",
    offset: 0.66667
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffbcc",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 32.232,
    x2: 41.601,
    y1: 52.825,
    y2: 65.947,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    spreadMethod: "reflect"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 44.906,
    x2: 51.25,
    y1: 38.795,
    y2: 47.564,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    spreadMethod: "reflect"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-318.95 -121.02)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m358.85 126.47 14.773-1.779 0.08963 62.032-38.894-34.263v31.593l-14.862 1.7817v-63.814l38.894 35.779v-31.33z",
    fill: "url(#c)",
    stroke: "url(#b)",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8b5b8d7a056b53d674f750a4fbcc645c.svg";
export { ForwardRef as ReactComponent };